import formsBackendClient, { ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';
import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/external-data-sets/by-slugs/versions']['GET'];
type Input = ThisApi['query'];

const getDataReferenceVersionsBySlugs = async ({ slugs }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/external-data-sets/by-slugs/versions');
  const data = await formsBackendClient.get(path, { params: { slugs } });
  return data.data;
};

export default getDataReferenceVersionsBySlugs;